export const banner = {
  banners: "Banners",
  banner: "Banner",
  search: "Search",
  advanceFilter: "Advance Filter",
  keyname: "Key Name",
  slug: "Slug",
  close: "close",
  filter: "filter",
  edit: "Edit",
  createBanner: "Create Banner",
  editBanners: "Edit Banner",
  description: "Description",
  schedulerStartDate: "Scheduler Start Date",
  schedulerStartTime: "Scheduler Start Time",
  schedulerEndDate: "Scheduler End Date",
  schedulerTimeEnd: "Scheduler Time End",
  schedulerRepeat: "Scheduler Repeat",
  monday: "MONDAY",
  sunday: "SUNDAY",
  tuesday: "TUESDAY",
  wednesday: "WEDNESDAY",
  thuesday: "THUSEDAY",
  friday: "FRIDAY",
  saturday: "SATURDAY",
  image: "image",
  addMoreImage: "add more image",
  onetimeDisplay: "One-Time Display",
  useScheduler: "Use Scheduler",
  submit: "submit",
  id: "ID",
  publish: "PUBLISH",
  dateCreated: "DATE CREATED",
  true: "TRUE",
  false: "FALSE",
  edit: "Edit",
  delete: "Delete",
  previewImage: "Preview Image",
  submit: "Submit",
  linkTo: "Link To URL",
  home: 'home',
  dashboard: 'dashboard',
  commission: 'commission',
  affiliate: 'affiliate',
  reward: 'reward',
  deposit: 'deposit',
  withdraw: 'withdraw',
  transaction: 'transaction',
  history: 'history',
};
